/**
 * @author LiangYongJia, RuleError用于创建校验的错误
 */
export default class RuleError extends Error {
  constructor(...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RuleError);
    }
    this.name = 'RuleError';
  }
}
